import { AnchorTitle } from "#components/ui/anchor-title"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "#components/ui/card"
import { Separator } from "#components/ui/separator"
import { Body, H3 } from "#components/ui/typography"
import { useI18n } from "#hooks/use-i18n"
import { Globe, Mail, Users } from "lucide-react"

export function SettingsHelp() {
  const { t } = useI18n()

  return (
    <div className="space-y-6">
      <div>
        <H3 className="mb-2">{t("pages.help.settings.overview.title")}</H3>
        <Body className="text-muted-foreground">
          {t("pages.help.settings.overview.description")}
        </Body>
      </div>

      <Card id="settings-general">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="settings-general">
              {t("pages.help.settings.general.title")}
            </AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.settings.general.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-start gap-3">
            <Globe className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.settings.general.preferences.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.settings.general.preferences.description")}
              </Body>
            </div>
          </div>

          <Separator />

          <div className="flex items-start gap-3">
            <Users className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.settings.general.accountAccess.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.settings.general.accountAccess.description")}
              </Body>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card id="settings-invitations">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="settings-invitations">
              {t("pages.help.settings.invitations.title")}
            </AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.settings.invitations.description")}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex items-start gap-3">
            <Mail className="w-5 h-5 mt-0.5 text-primary flex-shrink-0" />
            <div className="flex-1">
              <Body className="font-semibold mb-1">
                {t("pages.help.settings.invitations.send.title")}
              </Body>
              <Body className="text-muted-foreground text-sm">
                {t("pages.help.settings.invitations.send.description")}
              </Body>
            </div>
          </div>

          <Separator />

          <div>
            <Body className="font-semibold mb-2">
              {t("pages.help.settings.invitations.manage.title")}
            </Body>
            <Body className="text-muted-foreground text-sm">
              {t("pages.help.settings.invitations.manage.description")}
            </Body>
          </div>

          <Separator />

          <div>
            <Body className="font-semibold mb-2">
              {t("pages.help.settings.invitations.filter.title")}
            </Body>
            <Body className="text-muted-foreground text-sm">
              {t("pages.help.settings.invitations.filter.description")}
            </Body>
          </div>
        </CardContent>
      </Card>

      <Card id="settings-data">
        <CardHeader>
          <CardTitle>
            <AnchorTitle id="settings-data">{t("pages.help.settings.data.title")}</AnchorTitle>
          </CardTitle>
          <CardDescription>{t("pages.help.settings.data.description")}</CardDescription>
        </CardHeader>
        <CardContent>
          <Body className="text-muted-foreground text-sm">
            {t("pages.help.settings.data.content")}
          </Body>
        </CardContent>
      </Card>
    </div>
  )
}
